module.exports = __webpack_public_path__ + "c68de57dab1f4634a7575c279b764128.pdf";